import React from "react";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./css/style.css";
import "./css/satoshi.css";
import "jsvectormap/dist/jsvectormap.css";
import "flatpickr/dist/flatpickr.min.css";
import { store } from "./redux/store";
import "./i18n";
import "aos/dist/aos.css";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { config } from "./config/config";

const clientId = config.GOOGLE_CLIENT_ID;
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <GoogleOAuthProvider
        clientId={clientId}
      >
        <App />
      </GoogleOAuthProvider>
    </Provider>
  </React.StrictMode>
);

// TODO: add a script to run the app in dev mode
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
